import { useCallback, useEffect, useState } from 'preact/compat';
export default function useTotal(items, misc) {
    const [total, setTotal] = useState(0);
    const calculateTotal = useCallback(() => {
        const itemsReducer = items.reduce((carry, item) => carry + item.PriceBands.reduce((bandCarry, band) => bandCarry + (band.UnitPrice * band.Units), 0), 0);
        const miscReducer = misc.reduce((carry, item) => carry + item.PriceBands.reduce((bandCarry, band) => bandCarry + (band.UnitPrice * band.Units), 0), 0);
        setTotal(itemsReducer + miscReducer);
    }, [items, misc]);
    useEffect(calculateTotal, [calculateTotal, items, misc]);
    return total;
}
